export default "__VITE_ASSET__BjxU$5iI__"